// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Kwwe","header":"_3YWvn","content":"_27Nev","controls":"_1m3x1"};